import * as React from "react";
import Container from "@mui/material/Container";
import EventList from "../components/event/eventList";
import ScrollToTop from "../components/scrollToTop";

export default function Event() {
  return (
    <Container maxWidth={false} disableGutters>
      <ScrollToTop />
      <EventList />
    </Container>
  );
}
